import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_f_paywall_before_after~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fasting_f_paywall_before_after'),
			},
		},
	},
]

export default config
